export function buildAccountDeltas(tx, meta) {
    const keys = resolveAccountKeys(tx, meta);
    const deltas = [];
    for (let i = 0; i < keys.length; i++) {
        const preLamports = meta.preBalances[i] ?? 0;
        const postLamports = meta.postBalances[i] ?? 0;
        const lamportsDelta = postLamports - preLamports;
        const preTokens = (meta.preTokenBalances ?? []).filter((t) => t.accountIndex === i);
        const postTokens = (meta.postTokenBalances ?? []).filter((t) => t.accountIndex === i);
        const tokenDeltas = buildTokenDeltas(preTokens, postTokens);
        deltas.push({
            pubkey: keys[i],
            preLamports,
            postLamports,
            lamportsDelta,
            preTokens,
            postTokens,
            tokenDeltas,
        });
    }
    // Filter to accounts with actual changes
    return deltas.filter((d) => d.lamportsDelta !== 0 ||
        d.tokenDeltas.length > 0 ||
        d.preTokens.length > 0 ||
        d.postTokens.length > 0);
}
function buildTokenDeltas(pre, post) {
    const mints = new Set([...pre.map((t) => t.mint), ...post.map((t) => t.mint)]);
    const deltas = [];
    for (const mint of mints) {
        const preAmount = pre.find((t) => t.mint === mint)?.uiTokenAmount.amount ?? '0';
        const postAmount = post.find((t) => t.mint === mint)?.uiTokenAmount.amount ?? '0';
        const delta = BigInt(postAmount) - BigInt(preAmount);
        if (delta !== 0n) {
            const decimals = post.find((t) => t.mint === mint)?.uiTokenAmount.decimals ??
                pre.find((t) => t.mint === mint)?.uiTokenAmount.decimals ??
                0;
            const uiDelta = decimals > 0
                ? Number(delta) / Math.pow(10, decimals)
                : Number(delta);
            deltas.push({
                mint,
                delta: delta.toString(),
                decimals,
                uiDelta: Math.abs(uiDelta) > 0 ? uiDelta : null,
            });
        }
    }
    return deltas;
}
function resolveAccountKeys(tx, meta) {
    const keys = [...tx.message.accountKeys];
    if (meta.loadedAddresses) {
        keys.push(...meta.loadedAddresses.writable, ...meta.loadedAddresses.readonly);
    }
    return keys;
}
//# sourceMappingURL=account-diff.js.map